import { ASYNC_STATUS_ID } from 'constants/index'
import { API } from 'constants/apiEndPoints'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'

export const useUserPreferencesData = () => {
  const [data, setData] = useState({})
  const [isPending, setPending] = useState()

  // GET DATA
  const [apiGetState, sendGetApiQuery, hasGetApiStatus] = useAPI(API.ACCOUNT_GET_PREFERENCES, {
    queryType: 'get',
    withJwt: true,
    controlled: true,
  })

  useEffect(() => {
    setPending('all')
    sendGetApiQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasGetApiStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      if (!Object.keys(apiGetState.data).length) return null
      const data = apiGetState.data?.response?.preferences

      setData(data)
      setPending(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiGetState.status?.id, apiGetState?.data])

  // UPDATE DATA

  const [apiPostState, sendPostApiQuery, hasPostApiStatus] = useAPI(API.ACCOUNT_UPDATE_PREFERENCES, {
    withJwt: true,
    controlled: true,
  })
  const updateData = useCallback(
    (newPrefObj) => {
      if (isPending) return
      const key = Object.keys(newPrefObj).at(0)
      setPending(key)
      const composedData = { ...data, ...newPrefObj }
      const newData = {
        userPreference: {
          openOrderEmail: !!composedData.openOrderEmail,
          closedOrderEmail: !!composedData.closedOrderEmail,
          bustedOrderEmail: !!composedData.bustedOrderEmail,
          updateEmails: !!composedData.updateEmails,
          chatOpen: false,
        },
      }
      sendPostApiQuery({ params: newData })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isPending, data]
  )

  useEffect(() => {
    if (hasPostApiStatus(ASYNC_STATUS_ID.ERROR)) setPending(null)

    if (hasPostApiStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      if (!Object.keys(apiPostState.data).length) return null
      const data = apiPostState.data?.response?.preferences
      setData(data)
      setPending(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiPostState.status?.id, apiPostState?.data])

  return { isPending, data, updateData }
}
